import React from 'react';
import { Counter, Form, CheckboxLabel, Input, TooltipHelp, Section, Icon } from '@weezevent/nacre';
import Style from './automaticForm.module.css';
import PreviewGenerateCode from './previewGenerateCode';
import { useTranslation } from 'react-i18next';
import { useSegment } from '../../../components/tracking/trackingProvider';
import PropTypes from 'prop-types';

export default function AutomaticForm({ discountForm, onDiscounts }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    const { quantity, numberOfUse, name, prefix, unlimited } = discountForm;
    const [preview, setPreview] = React.useState(false);

    const generateRandomCode = (prefix = '') => {
        const lengthCode = 12 - prefix.length;
        let result = '';
        const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        const charactersLength = characters.length;
        for (let i = 0; i < lengthCode; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return `${prefix}${result}`;
    };

    const handleChange = (value, type) => {
        let _tmpDiscounts = [...discountForm.discounts];
        if (type === 'quantity') {
            if (+quantity < +value) {
                _tmpDiscounts = [
                    ..._tmpDiscounts,
                    ...[...Array(Number(value - _tmpDiscounts.length)).keys()].map((discount, index) => ({
                        code: generateRandomCode(prefix),
                        quota: unlimited ? null : numberOfUse || 0,
                        name: name
                    }))
                ];
            } else {
                _tmpDiscounts = [..._tmpDiscounts].slice(0, value);
            }
        } else {
            _tmpDiscounts = [..._tmpDiscounts.map(discount => ({ ...discount, [type]: type === 'code' ? generateRandomCode(value) : value }))];
        }
        onDiscounts('discounts', _tmpDiscounts);
    };

    React.useEffect(() => {
        if (discountForm.discounts.length === 0) {
            let _tmpDiscounts = [...discountForm.discounts];
            _tmpDiscounts = [...Array(Number(quantity)).keys()].map((discount, index) => ({
                code: generateRandomCode(prefix),
                quota: unlimited ? null : numberOfUse || 0,
                name: name
            }));
            onDiscounts('discounts', _tmpDiscounts);
        }
    }, [quantity]);

    return (
        <>
            <Section>
                <Form.Field className={Style['automatic-form']}>
                    <Form.Label label={t('ticket.discountForm.automatic.quantity')} />
                    <Counter
                        style={{ width: '150px' }}
                        onChange={(_, value) => {
                            onDiscounts('quantity', value);
                            handleChange(value, 'quantity');
                        }}
                        value={quantity}
                        min={0}
                        max={100}
                        errors={quantity <= 0 ? true : false}
                    />
                    <Form.Sublabel label="Max. 100" style={{ marginTop: '5px' }} />
                </Form.Field>
                {quantity <= 0 && <Form.FieldErrors errors={[t('ticket.discountForm.automatic.error')]} />}
                <div>
                    <Form.Field className={Style['automatic-form']}>
                        <Form.Label label={t('ticket.discountForm.automatic.quota')} />
                        <div style={{ display: 'flex' }}>
                            <Counter
                                style={{ width: '150px' }}
                                onChange={(_, value) => {
                                    onDiscounts('numberOfUse', value);
                                    handleChange(unlimited ? null : value, 'quota');
                                }}
                                value={numberOfUse}
                                disabled={unlimited}
                                min={0}
                                max={999}
                                errors={numberOfUse <= 0 ? true : false}
                            />
                            <CheckboxLabel
                                label={t('ticket.discountForm.automatic.unlimited')}
                                name={'unlimited'}
                                checked={unlimited}
                                value={unlimited}
                                onChange={(_, { checked }) => {
                                    handleChange(checked ? null : numberOfUse, 'quota');
                                    onDiscounts('unlimited', checked);
                                }}
                            />
                        </div>
                        {numberOfUse <= 0 && <Form.FieldErrors errors={[t('ticket.discountForm.automatic.error')]} />}
                    </Form.Field>
                </div>
                <Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Form.Label className="" label={t('ticket.discountForm.automatic.name')} optionalText={null} required={false} />
                        <TooltipHelp position="bottom" triggerOnHover title={t('ticket.discountForm.automatic.tooltip_name')} />
                        <Form.Sublabel className="Sty" label={t('ticket.discountForm.automatic.optional')} />
                    </div>
                    <Input
                        value={name}
                        onChange={({ target: { value } }) => {
                            onDiscounts('name', value);
                            handleChange(value, 'name');
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Form.Label className="" label={t('ticket.discountForm.automatic.prefix')} optionalText={null} required={false} />
                        <TooltipHelp position="bottom" triggerOnHover title={t('ticket.discountForm.automatic.tooltip_prefix')} />
                        <Form.Sublabel className="" label={t('ticket.discountForm.automatic.optional')} />
                    </div>
                    <Input
                        value={prefix}
                        maxLength={5}
                        onChange={({ target: { value } }) => {
                            onDiscounts('prefix', value);
                            handleChange(value, 'code');
                        }}
                    />
                </Form.Field>
            </Section>
            <span
                onClick={() => {
                    track('ACTION > PREVIEW DISCOUNT', { 'Page Title': 'CREATE DISCOUNT', Application: 'WeezTicket nBO', 'Preview status': preview ? 'Hidden' : 'Displayed' });
                    setPreview(!preview);
                }}
                className={Style['link-preview']}
            >
                <Icon className={Style['link-preview__icon']} name="eye" size="small" />
                {t('ticket.discountForm.automatic.preview')}
            </span>
            {preview && (
                <Form.Field className={Style['overview']}>
                    <PreviewGenerateCode discounts={discountForm.discounts} discounts_list={discountForm.discounts.filter((_, i) => i < 5)} />
                </Form.Field>
            )}
        </>
    );
}

AutomaticForm.propTypes = {
    onDiscounts: PropTypes.func.isRequired,
    discountForm: PropTypes.object.isRequired
};
